import { Scheme } from 'types/user';
import { PAID_SCHEMES } from 'common/constants/schemes';

const isSchemePaid = (scheme: Scheme | null) =>
  Boolean(scheme && PAID_SCHEMES.includes(scheme.schemeType));

export default isSchemePaid;
